// SSS ekranlarinda diller her yerde ayni sirada gosterilir: once TR, sonra EN,
// ardindan alfabetik. Servis (faq/get) dilleri kayit sirasina gore dondurdugu icin
// listede gruptan gruba degisiyordu; burada tek noktadan normalize edilir.
export const compareLanguageCode = (a, b) => {
    const first = a || '';
    const second = b || '';

    if (first === second) return 0;
    if (first === 'tr') return -1;
    if (second === 'tr') return 1;
    if (first === 'en') return -1;
    if (second === 'en') return 1;

    return first.localeCompare(second);
};

// getCode: elemandan dil kodunu okuyan fonksiyon (liste `language_code`, dil servisi `code` kullanir)
export const sortByLanguageCode = (list, getCode) =>
    (Array.isArray(list) ? [...list] : []).sort((a, b) => compareLanguageCode(getCode(a), getCode(b)));

export default sortByLanguageCode;
